/* eslint-disable max-lines */
import React, { ReactElement, memo } from "react";

function Smiling(): ReactElement {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint0_radial_1656_104674)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint1_radial_1656_104674)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint2_radial_1656_104674)"
                fillOpacity="0.6"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint3_radial_1656_104674)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint4_radial_1656_104674)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint5_radial_1656_104674)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint6_radial_1656_104674)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint7_radial_1656_104674)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint8_radial_1656_104674)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint9_radial_1656_104674)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint10_radial_1656_104674)"
            />
            <path
                d="M10.4208 16.2244C12.7437 16.2244 14.6268 14.3414 14.6268 12.0185C14.6268 9.69557 12.7437 7.8125 10.4208 7.8125C8.09792 7.8125 6.21484 9.69557 6.21484 12.0185C6.21484 14.3414 8.09792 16.2244 10.4208 16.2244Z"
                fill="white"
            />
            <path
                d="M21.57 16.3011C23.9141 16.3011 25.8143 14.4009 25.8143 12.0568C25.8143 9.71274 23.9141 7.8125 21.57 7.8125C19.2259 7.8125 17.3257 9.71274 17.3257 12.0568C17.3257 14.4009 19.2259 16.3011 21.57 16.3011Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.4001 18.2001C10.8419 17.8687 11.4687 17.9582 11.8001 18.4001C12.1094 18.8125 13.5118 20.0001 16.0001 20.0001C18.4883 20.0001 19.8907 18.8125 20.2001 18.4001C20.5314 17.9582 21.1582 17.8687 21.6001 18.2001C22.0419 18.5314 22.1314 19.1582 21.8001 19.6001C21.1094 20.5209 19.1118 22.0001 16.0001 22.0001C12.8883 22.0001 10.8907 20.5209 10.2001 19.6001C9.86869 19.1582 9.95823 18.5314 10.4001 18.2001Z"
                fill="url(#paint11_radial_1656_104674)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 14C12.1046 14 13 13.1046 13 12C13 10.8954 12.1046 10 11 10C9.89543 10 9 10.8954 9 12C9 13.1046 9.89543 14 11 14ZM21 14C22.1046 14 23 13.1046 23 12C23 10.8954 22.1046 10 21 10C19.8954 10 19 10.8954 19 12C19 13.1046 19.8954 14 21 14Z"
                fill="url(#paint12_linear_1656_104674)"
            />
            <defs>
                <radialGradient
                    id="paint0_radial_1656_104674"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(25.5 9) rotate(131.878) scale(38.9487)"
                >
                    <stop stopColor="#FFF478" />
                    <stop offset="0.474827" stopColor="#FFB02E" />
                    <stop offset="1" stopColor="#F70A8D" />
                </radialGradient>
                <radialGradient
                    id="paint1_radial_1656_104674"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16 12.5) rotate(101.31) scale(17.8466 22.8581)"
                >
                    <stop offset="0.787821" stopColor="#F59639" stopOpacity="0" />
                    <stop offset="0.972509" stopColor="#FF7DCE" />
                </radialGradient>
                <radialGradient
                    id="paint2_radial_1656_104674"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(18 14) rotate(135) scale(41.0122)"
                >
                    <stop offset="0.314853" stopOpacity="0" />
                    <stop offset="1" />
                </radialGradient>
                <radialGradient
                    id="paint3_radial_1656_104674"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16 17) rotate(77.692) scale(28.1469)"
                >
                    <stop offset="0.507903" stopColor="#7D6133" stopOpacity="0" />
                    <stop offset="1" stopColor="#715B32" />
                </radialGradient>
                <radialGradient
                    id="paint4_radial_1656_104674"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16.5 16.5) rotate(55.7131) scale(13.3135 9.65032)"
                >
                    <stop stopColor="#FFB849" />
                    <stop offset="1" stopColor="#FFB847" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint5_radial_1656_104674"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(20.5 18) rotate(9.86581) scale(11.6726)"
                >
                    <stop stopColor="#FFA64B" />
                    <stop offset="0.900412" stopColor="#FFAE46" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint6_radial_1656_104674"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(17.5 15) rotate(43.9708) scale(59.0529)"
                >
                    <stop offset="0.185425" stopOpacity="0" />
                    <stop offset="1" stopOpacity="0.4" />
                </radialGradient>
                <radialGradient
                    id="paint7_radial_1656_104674"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(9.60712 12.5548) rotate(101.574) scale(4.74729)"
                >
                    <stop offset="0.177535" stopColor="#392108" />
                    <stop offset="1" stopColor="#C87928" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint8_radial_1656_104674"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(20.3766 11.8455) rotate(124.895) scale(4.01162)"
                >
                    <stop offset="0.10085" stopColor="#392108" />
                    <stop offset="1" stopColor="#C87928" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint9_radial_1656_104674"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(21.3236 12.7857) rotate(107.802) scale(3.9775)"
                >
                    <stop offset="0.359039" stopColor="#C84E28" />
                    <stop offset="1" stopColor="#C84528" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint10_radial_1656_104674"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(10.3844 12.6474) rotate(74.6785) scale(4.23372)"
                >
                    <stop offset="0.359039" stopColor="#C84E28" />
                    <stop offset="1" stopColor="#C84528" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint11_radial_1656_104674"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16.0001 17.0001) rotate(90) scale(5.5 8.41855)"
                >
                    <stop offset="0.34763" stopColor="#241A1A" />
                    <stop offset="0.628228" stopColor="#57444A" />
                    <stop offset="1" stopColor="#4E2553" />
                    <stop offset="1" stopColor="#502A56" />
                </radialGradient>
                <linearGradient
                    id="paint12_linear_1656_104674"
                    x1="16.4375"
                    y1="9.33333"
                    x2="15.9253"
                    y2="14.0395"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#553B3E" />
                    <stop offset="1" stopColor="#3D2432" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export default memo(Smiling);
